import { makeStyles } from "tss-react/mui";
import { COL_WIDTH_NHC } from "@miplatform/constants";
import { useDroppable } from "@dnd-kit/core";
import { SortableContext, rectSortingStrategy } from "@dnd-kit/sortable";
import { Box, Grid } from "@mui/material";

const useStyles = makeStyles()((theme) => ({
  column: {
    flex: 1,
    backgroundColor: theme.palette.blue.light,
  },
  container: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    height: "100%",
    width: "100%",
    alignContent: "start",
    minWidth: COL_WIDTH_NHC,
  },
}));

export function Column({ children, id, cards = [] }) {
  const { classes } = useStyles();
  const { setNodeRef } = useDroppable({ id });

  return (
    <SortableContext
      id={id}
      items={cards.map((card) => ({
        id: card.uuid,
      }))}
      strategy={rectSortingStrategy}
    >
      <Grid data-testid="kanban-column" container className={classes.column}>
        <Box ref={setNodeRef} className={classes.container}>
          {children}
        </Box>
      </Grid>
    </SortableContext>
  );
}
